<div class="trial-banner" *ngIf="isTrialEligibleGuestUser$ | async">
  <div class="trial-banner__left">
    <app-pencil-icon
      class="trial-banner__rocket-icon"
      name="noto_rocket"
      [type]="IconTypes.svgIcon"
    ></app-pencil-icon>
    <span class="trial-banner__text">
      {{
        'Unlock the full platform with video calling, apps, and recordings, free for 14 days'
          | translate
      }}
    </span>
  </div>
  <app-pencil-button
    class="trial-banner__button"
    [theme]="PencilButtonThemeEnum.SECONDARY_OUTLINE"
    [icon]="'noto_rocket'"
    [iconConfig]="{ type: IconTypes.svgIcon }"
    [label]="'Start free trial' | translate"
    (clickEvent)="startFreeTrial()"
    data-name="payment-trial-banner-start-free-trial"
  ></app-pencil-button>
</div>
